<template>
  <div
    class="modal modal--absolute"
    v-bind:class="{ 'modal--visible': isOpen }"
  >
    <div class="modal__window">
      <div class="modal__window__header">
        <h2>
          <slot name="header"></slot>
        </h2>
        <button @click="closeModal()" style="font-size: 29px; top: 0.6rem;">
          &times;
        </button>
      </div>
      <div class="modal__window__content">
        <slot name="content"></slot>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  props: {
    isOpen: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapActions[('general/setModalOpenStatus', 'general/setLayoutOption')],
    ...mapState(['general'])
  },
  methods: {
    closeModal() {
      this.$store.dispatch('general/setModalOpenStatus', false);

      if (this.general.modalOnlyFlag) {
        this.$store.dispatch('general/setLayoutOption', ['sidebarRight', false])
        this.$store.dispatch('general/setLayoutOption', ['sidebarLeft', false])
      }
    }
  }
};
</script>

<style scoped>
.modal__window {
  padding: 0;
}

.modal__window__header {
  background: white;
}

.modal__window__content {
  padding: 15px;
  font-size: 11px;
}
</style>
